<script setup lang="ts">
  import { onMounted, onUnmounted } from 'vue';

  import { trackWithSegment } from '@/segment';

  import Features from './components/Features.vue';
  import Footer from './components/Footer.vue';
  import Header from './components/Header.vue';
  import Plans from './components/Plans.vue';

  onMounted(() => {
    window.scrollTo({ top: 0 });

    trackWithSegment({ event: 'comparePlansPageViewed' });
  });

  onUnmounted(() => {
    trackWithSegment({ event: 'comparePlansPageExited' });
  });
</script>

<template>
  <div id="feature-enrollment-compare-plans" class="tw-overflow-hidden tw-bg-white">
    <Header />
    <Plans />
    <Features />
    <Footer />
  </div>
</template>
